import { render, staticRenderFns } from "./VesselCertificateType.vue?vue&type=template&id=1dd6644f&scoped=true"
import script from "./VesselCertificateType.vue?vue&type=script&lang=js"
export * from "./VesselCertificateType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd6644f",
  null
  
)

export default component.exports